export function dasherize(target) {
    // prettier-ignore
    return target
        .replace(/([A-Z])/g, (_match, p1) => `-${p1.toLowerCase()}`)
        .replace(/\s/g, '-');
}
//# sourceMappingURL=string.js.map